import { render, staticRenderFns } from "./bjplfx.vue?vue&type=template&id=6d391aa6&scoped=true&"
import script from "./bjplfx.vue?vue&type=script&lang=js&"
export * from "./bjplfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d391aa6",
  null
  
)

export default component.exports